import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Row, Col, Alert } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import Autocomplete from 'react-autocomplete';

import Flag from '../../../../components/Flag/Flag';
import { getShippingFeeAmount } from '../../ShippingFeeActions';
import { getCartShipping, setShippingAddress, setShippingAmount } from '../../../Cart/CartActions';
import { getLanguagePath } from '../../../Intl/IntlActions';
import { getAvalaibleCountries } from '../../../App/AppActions';


class ShippingCalculator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            countryInput: '',
        };

        this.countries = getAvalaibleCountries();
    }

    // componentDidUpdate(prevProps, prevState) {
    //     if(!prevProps.shipping || !this.props.shipping || prevProps.shipping.address.countryCode !== this.props.shipping.address.countryCode) {
    //         this.props.dispatch(setShippingAmount(this.props.shippingFeeAmount));
    //     }
    // }

    getCountryNameTranslation(item) {
        let name = '';
        switch(this.props.intl.locale) {
            case 'fr':
                name = item.translations.fra && item.translations.fra.common;
                break;

            case 'de':
                name = item.translations.deu && item.translations.deu.common;
                break;

            case 'es':
                name = item.translations.spa && item.translations.spa.common;
                break;

            default:
                name = item.name.common;
        }
        return name || item.name.common;
    }

    handleSelectCountry = countryCode => {
        this.props.dispatch(setShippingAddress({
            countryCode,
            country: this.getCountryNameTranslation(this.countries.find(country => country.cca2 === countryCode)),
        }));
    }

    handleResetShipping = event => {
        event.preventDefault();
        this.props.dispatch(setShippingAddress());
    }

    renderCountrySelector() {
        return (
            <Autocomplete
                getItemValue={item => item.cca2}
                items={this.countries}
                renderItem={(item, isHighlighted) => (
                    <div key={item.cca2} className="p-2" style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                        {this.getCountryNameTranslation(item)}
                    </div>
                )}
                shouldItemRender={(item, value) => this.getCountryNameTranslation(item).toLowerCase().indexOf(value.toLowerCase()) > -1}
                value={this.state.countryInput}
                onChange={event => this.setState({ countryInput: event.target.value })}
                onSelect={this.handleSelectCountry}
                inputProps={{
                    className: 'form-control',
                    placeholder: this.props.intl.formatMessage({ id: 'countrySelectPlaceholder', defaultMessage: 'Select a country' }),
                }}
                wrapperStyle={{}}
                menuStyle={{
                    borderRadius: '3px',
                    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                    padding: '2px 0',
                    fontSize: '90%',
                    position: 'fixed',
                    overflow: 'auto',
                    maxHeight: '50%',
                    zIndex: 999,
                    background: '#fff',
                }}
            />
        );
    }

    render() {
        const { shipping, shippingFeeAmount } = this.props;

        if(shipping && shipping.address && shipping.address.countryCode && !shippingFeeAmount) {
            return (
                <Alert color="danger" className="text-center">
                    <FontAwesome name="exclamation-circle" /> <FormattedMessage id="cartShippingUnavailableAlert" defaultMessage="We cannot deliver to your region!" /><br />
                    <Link to={getLanguagePath('/transport-policy', this.props.intl.locale)} className="text-uppercase text-underline"><FormattedMessage id="cartShippingUnavailableLink" defaultMessage="See the list of countries" /></Link>{' - '}
                    <a href="#" className="text-uppercase text-underline" onClick={this.handleResetShipping}><FormattedMessage id="edit" defaultMessage="Edit" /></a>
                </Alert>
            );
        }
        if(shipping && shipping.address && shipping.address.countryCode) {
            return (
                <Row>
                    <Col xs="12" md="6">
                        <span className="d-block text-dark special-font text-right">
                            <strong><FormattedMessage id="cartShippingCalculatedTitle" defaultMessage="Shipping and VAT charges" /></strong>
                        </span>
                    </Col>
                    <Col>
                        <div className="text-dark text-right">
                            <strong><FormattedMessage id="cartShippingSetAlert" defaultMessage="You want to be delivered in {country}" values={{ country: shipping.address.country }} /></strong>
                            {' '}<Flag country={shipping.address.countryCode} />
                            <br />
                            <a href="#" className="text-uppercase text-underline" onClick={this.handleResetShipping}><FormattedMessage id="edit" defaultMessage="Edit" /></a>
                        </div>
                    </Col>
                </Row>
            );
        }
        return (
            <Row>
                <Col xs="12" md="6">
                    <span className="text-dark special-font">
                        <strong><FormattedMessage id="cartShippingCalculationTitle" defaultMessage="Calculate your shipping and VAT charges." /></strong><br />
                        <FormattedMessage id="cartShippingCalculationText" defaultMessage="Enter your delivery country" />
                    </span>
                </Col>
                <Col>
                    {this.renderCountrySelector()}
                </Col>
            </Row>
        );
    }
}

function mapStateToProps(store, props) {
    const shipping = getCartShipping(store);
    return {
        shipping,
        shippingFeeAmount: shipping ? getShippingFeeAmount(store, shipping.address) : null,
    };
}

ShippingCalculator.defaultProps = {
    shipping: null,
    shippingFeeAmount: null,
};

ShippingCalculator.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    shipping: PropTypes.object,
    shippingFeeAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default connect(mapStateToProps)(injectIntl(ShippingCalculator));
